doulaeasy.show_register_modal = function () {
	$('#register_modal').modal('show');
}
doulaeasy.show_parent_register_modal = function () {
	$('#parent_register_modal').modal('show');
}
doulaeasy.show_helper_register_modal = function () {
	$('#helper_register_modal').modal('show');
}